import FileDownloaderApi from './FileDownloaderApi'

export default class ReportingFileDownloaderApi extends FileDownloaderApi {
  getEnrollmentReports = (options = {}) => {
    return this.post('/api/v1/private/enrollments/reports', options.params)
  };

  getReportDownload = (options = {}) => {
    return this.post(`/api/v1/private/reports`, options.params)
  };

  getMultipleReportsDownload = (options = {}) => {
    return this.post('/api/v1/private/multiplereports', options.body)
  };
}
